import React, {Fragment} from "react";
import PropTypes from "prop-types";
import {FaSolidIcon} from "../../../../components/FontAwesomeIcons";
import i18n from "../../../../i18n";
import ModalPortalHOC from "../../../../components/BaseComponents/ModalPortalHOC";
import AppConfig from "../../../../config/AppConfig";
import AuthAPI from "../../../../api/AuthAPI";
import IframeModal from "../../../../components/Modals/IframeModal";

export class DashboardModuloDipendentiButton extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            pageOpen: false,
        }
    }

    handlePageOpen = _ => {
        this.setState({pageOpen: true});
    }
    handlePageClose = _ => this.setState({pageOpen: false});

    getDashboardUrl = _ => {
        const redirectRoute = btoa(`/admin/modulo-hr/dipendenti/dashboard/mobile-embed?embed=1`);
        return `${AppConfig.webServerUrl}/api/dashboard/autologin/${AuthAPI.getUserAccessToken()}?redirect=${redirectRoute}`;
    }

    render() {
        return (
            <Fragment>
                <div className={"d-flex align-items-center justify-content-between p-3 border-top text-purple"}
                     onClick={this.handlePageOpen}
                >
                    <span>
                        <FaSolidIcon name={"users"}/>&nbsp;
                        {i18n.t(`launcher.side-menu.${this.props.labelName}`)}
                    </span>
                </div>
                <ModalPortalHOC>
                    {
                        (this.state.pageOpen) &&
                        <IframeModal
                            src={this.getDashboardUrl()}
                            title={i18n.t(`launcher.side-menu.${this.props.labelName}`)}
                            onDismiss={this.handlePageClose}
                        />
                    }
                </ModalPortalHOC>
            </Fragment>
        )
    }

}

DashboardModuloDipendentiButton.propTypes = {
    labelName: PropTypes.string.isRequired,
    userNegozio: PropTypes.object,
}
